var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStartPackage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.11328 4.96094L7.99995 8.3676L13.8466 4.98094",
    stroke: "#68717B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 14.406V8.35938",
    stroke: "#68717B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.61993 1.65678L3.05993 3.63011C2.25326 4.07678 1.59326 5.19678 1.59326 6.11678V9.88344C1.59326 10.8034 2.25326 11.9234 3.05993 12.3701L6.61993 14.3501C7.37993 14.7701 8.62659 14.7701 9.38659 14.3501L12.9466 12.3701C13.7533 11.9234 14.4133 10.8034 14.4133 9.88344V6.11678C14.4133 5.19678 13.7533 4.07678 12.9466 3.63011L9.38659 1.65011C8.61993 1.23011 7.37993 1.23011 6.61993 1.65678Z",
    stroke: "#68717B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartPackage);
export default __webpack_public_path__ + "static/media/startPackage.490e08bc1f9585edee3aed53fc9876cd.svg";
export { ForwardRef as ReactComponent };